import NoteItem from './NoteItem';

export default function NoteList({notes, onUpdate, onDelete}) {
    if (notes.length === 0) return <p className="empty">Aucune note.</p>;

    return (
        <ul className="note-list">
            {notes.map(note => (
                <NoteItem key={note.id} note={note} onUpdate={onUpdate} onDelete={onDelete}/>
            ))}
        </ul>
    );
}
